import type { ReactNode, Ref } from 'react';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

import { filterSettingsFab } from '../../activeFeatureFlags';
import { getTestId } from '../../utils/featureFlags/getTestId';

export type FilterSettingsMobileButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  ref?: Ref<HTMLButtonElement>;
};
export const FilterSettingsMobileButton = ({
  children,
  onClick,
  ref,
}: FilterSettingsMobileButtonProps) => {
  const { setOutcome } = useAbTesting();

  const onClickHandler = () => {
    onClick?.();

    // remove if A/B test is finished
    setOutcome(getTestId(filterSettingsFab), {
      COF1: 1,
    });
  };

  return (
    <Button ref={ref} className="flex h-[2.75rem] pr-1 sm:h-[2.25rem]" onClick={onClickHandler}>
      <div className="mr-auto w-full overflow-hidden text-left leading-normal hyphens-auto">
        {children}
      </div>
      <span className="icon-emp-arrow-medium-down size-4" />
    </Button>
  );
};
